export const getApiBaseUrl = () =>
  process.env.NODE_ENV === 'development'
    ? process.env.HJRX_API_ORIGIN || 'http://localhost:9200'
    : 'https://api.yanclo.com/hjrx';
